import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideCopropriete } from '../../../../config/aides-coproprietes';

export default function MprCoproPage() {
  const aide = getAideCopropriete('mpr-copro');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="coproprietes" />;
}
